import React from 'react'
import SkeletonBigItemArticle from '../../../Article/components/ItemArticle/views_default/BigItemArticle/skeleton'
import SkeletonSmallLandscapeItemArticle from '../../../Article/components/ItemArticle/views_default/SmallLandscapeItemArticle/skeleton'
import styled from 'styled-components'
import ContainerAd from '../../../../components/ContainerAd'
import DistrictTitleTopic from '../../../../components/TitleTopic/_views/DistrictTitleTopic'

const Wrapper = styled.div`
  padding-bottom: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    padding-bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    padding-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
`

const StyledContainerAd = styled(ContainerAd)`
  > div > div {
    margin-top: ${(props) => props.theme.sizes.gapVertical};
    margin-bottom: ${(props) => props.theme.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    > div > div {
      margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
      margin-bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
    }
  }
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    > div > div {
      margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
      margin-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
    }
  }
`

const WrapperInner = styled.div`
  margin-left: ${(props) => props.theme.sizes.gapEdge};
  margin-right: ${(props) => props.theme.sizes.gapEdge};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-left: ${(props) => props.theme.tablet.sizes.gapEdge};
    margin-right: ${(props) => props.theme.tablet.sizes.gapEdge};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-left: ${(props) => props.theme.mobile.sizes.gapEdge};
    margin-right: ${(props) => props.theme.mobile.sizes.gapEdge};
  }
  @media (max-width: 450px) {
    margin-left: 0;
    margin-right: 0;
  }
`

const WrapperSkeletonSmallLandscapeItemArticle = styled.div`
  margin-top: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
`

const WrapperSkeletonBigItemArticle = styled.div`
  margin-top: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
`

const SkeletonDistrict = ({ district, ...props }) => {
  let SmallLandscapeItemArticles = []
  for (let i = 0; i < 11; i++) {
    SmallLandscapeItemArticles.push(
      <WrapperSkeletonSmallLandscapeItemArticle key={i}>
        <SkeletonSmallLandscapeItemArticle />
      </WrapperSkeletonSmallLandscapeItemArticle>,
    )
  }
  return (
    <Wrapper {...props}>
      <DistrictTitleTopic title={district && district.label} district={district && district.value} />
      <WrapperInner>
        <WrapperSkeletonBigItemArticle>
          <SkeletonBigItemArticle />
        </WrapperSkeletonBigItemArticle>
        <StyledContainerAd />
        {SmallLandscapeItemArticles}
      </WrapperInner>
    </Wrapper>
  )
}

export default SkeletonDistrict
